export class FormBundleApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBundles() {
    return this.#http.get('/FormBundle');
  }

  async createBundle(body) {
    return this.#http.post('/FormBundle', body);
  }

  async editBundle({ formBundleId, ...body }) {
    return this.#http.put(`/FormBundle/${formBundleId}`, body);
  }

  async deleteBundle({ formBundleId }) {
    return this.#http.delete(`/FormBundle/${formBundleId}`);
  }

  async getBundleForLoan({ loanId }) {
    return this.#http.get(`/FormBundle/ForLoan/${loanId}`);
  }

  async getBundleHistory({ formBundleId }) {
    return this.#http.get(`/FormBundle/${formBundleId}/history`);
  }
}
